import { render, staticRenderFns } from "./SelectDeduction.vue?vue&type=template&id=38947dc5&scoped=true&"
import script from "./SelectDeduction.vue?vue&type=script&lang=js&"
export * from "./SelectDeduction.vue?vue&type=script&lang=js&"
import style0 from "./SelectDeduction.vue?vue&type=style&index=0&id=38947dc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38947dc5",
  null
  
)

export default component.exports